import {createAnatomy} from '@zag-js/anatomy';

export const radioButtonGroupAnatomy = createAnatomy(`radio-button-group`).parts(
  `group`,
  `item`,
  `item-icon`,
  `item-container`,
);

export const parts = radioButtonGroupAnatomy.build();

export type Part = keyof typeof parts;
